import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/Layout/Header/Header";
import Home from "./components/Pages/Home";

import "./assets/css/styles.css";

function App() {
    return (
        <div>
            <Header />
            <Home />
        </div>
    );
}

export default App;
